<div>
    <app-loader></app-loader>
    <app-header [userName]="userName"></app-header>
    <router-outlet></router-outlet>
    <app-footer *ngIf= "showFooter"></app-footer>
</div>
